import { render, staticRenderFns } from "./WorkRelationships.vue?vue&type=template&id=4ca07022&scoped=true"
import script from "./WorkRelationships.vue?vue&type=script&lang=js"
export * from "./WorkRelationships.vue?vue&type=script&lang=js"
import style0 from "./WorkRelationships.vue?vue&type=style&index=0&id=4ca07022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca07022",
  null
  
)

export default component.exports